/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/
import React, { useState } from 'react';
import { Menu, MenuItem, Divider, Typography, Button, styled } from '@mui/material';
import { BsBoxArrowLeft, BsPeople, BsHouse } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { BrowserView } from 'react-device-detect';
import { logout } from '../../../store/reducers/user/userAction';

// Styled Components for a modern look
const StyledMenu = styled(Menu)(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 12,
        minWidth: 200,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
    },
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "12px 16px",
    fontSize: "16px",
    "&:hover": {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
}));

const UserAvatar = () => {
    const [menuAnchor, setMenuAnchor] = useState(null);
    const navigate = useNavigate();
    const user = useSelector(state => state.user.user);
    const dispatch = useDispatch();

    const handleMenuOpen = (event) => setMenuAnchor(event.currentTarget);
    const handleMenuClose = () => setMenuAnchor(null);

    const handleLogout = () => {
        setMenuAnchor(null);
        dispatch(logout());
        navigate('/login');
    };

    return (
        <>
            <Button
                onClick={handleMenuOpen}
                sx={{ marginLeft: 'auto', textTransform: "none" }}
            >
                <BrowserView>
                    <Typography variant="h3" color="white">
                        {user?.username}
                    </Typography>
                </BrowserView>
            </Button>

            {/* Modern Styled Menu */}
            <StyledMenu
                anchorEl={menuAnchor}
                open={Boolean(menuAnchor)}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <StyledMenuItem onClick={() => { navigate("/dashboard"); handleMenuClose(); }}>
                    <BsHouse size={18} />
                    <Typography variant="body1">Dashboard</Typography>
                </StyledMenuItem>

                <Divider />

                <StyledMenuItem onClick={() => { navigate("/account"); handleMenuClose(); }}>
                    <BsPeople size={18} />
                    <Typography variant="body1">Account</Typography>
                </StyledMenuItem>

                <Divider />

                <StyledMenuItem onClick={handleLogout}>
                    <BsBoxArrowLeft size={18} />
                    <Typography variant="body1">Logout</Typography>
                </StyledMenuItem>
            </StyledMenu>
        </>
    );
};

export default UserAvatar;
